import arrowSvg from '../assets/images/icons/iconArrow.svg';
import documentSvg from '../assets/images/icons/iconDocument.svg';
import efficiencySvg from '../assets/images/icons/iconEfficiency.svg';
import efficiencyGif from '../assets/images/icons/efficiency.gif';
import flexibilitySvg from '../assets/images/icons/iconFlexibility.svg';
import flexibilityGif from '../assets/images/icons/flexibility.gif';
import operationSvg from '../assets/images/icons/iconOperation.svg';
import operationGif from '../assets/images/icons/operation.gif';
import savingSvg from '../assets/images/icons/iconSaving.svg';
import savingGif from '../assets/images/icons/saving.gif';
import videoSvg from '../assets/images/icons/iconVideo.svg';
import squigglyGif from '../assets/images/icons/squiggly.gif';
import straightGif from '../assets/images/icons/straight.gif';
import straightPng from '../assets/images/icons/straight.png';
import loaderGif from '../assets/images/icons/loader.gif';

const icons = {
	loader: {
		gif: loaderGif,
	},
	squiggly: {
		gif: squigglyGif,
	},
	straight: {
		gif: straightGif,
		png: straightPng,
	},
	arrow: {
		svg: arrowSvg,
	},
  document: {
		svg: documentSvg,
	},
  efficiency: {
		svg: efficiencySvg,
		gif: efficiencyGif,
	},
  flexibility: {
		svg: flexibilitySvg,
		gif: flexibilityGif,
	},
  operation: {
		svg: operationSvg,
		gif: operationGif,
	},
  saving: {
		svg: savingSvg,
		gif: savingGif,
	},
  video: {
		svg: videoSvg,
	},
};

export default icons;
